// Libs
import classNames from 'classnames/bind';
import { Box, CircularProgress, Stack } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
// Components, Layouts, Pages
import { BaseTimelineItem } from '~/components/common';
// Others
import useCheckScrollable from '~/utils/hooks/useCheckScrollable';
import { IActivity } from '~/utils/interface/activity';

// Styles, images, icons
import styles from './BaseTimeline.module.scss';

type Props = {
  data: IActivity[];
  onLoadMore: () => void;
  hasMore: boolean;
  loadMoreSize?: number;
  onView: (activity: IActivity) => void;
};

const cx = classNames.bind(styles);

const BaseTimeline = (props: Props) => {
  //#region Destructuring Props
  const { data, hasMore, loadMoreSize = 14, onLoadMore, onView } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  useCheckScrollable({ containerId: 'mainContentSection', onNotScrollable: onLoadMore });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='baseTimelineComponent' className={cx('container')}>
      <InfiniteScroll
        dataLength={data.length}
        next={onLoadMore}
        hasMore={hasMore}
        loader={
          <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} height={35}>
            <CircularProgress size={loadMoreSize} />
          </Stack>
        }
        scrollableTarget={'mainContentSection'}
        scrollThreshold={0.6}
        // endMessage={
        //   data?.length === DEFAULT_NUMBER_ZERO && (
        //     <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} height={35}>
        //       <Typography component={'p'} className={cx('noData')}>
        //         {t('common_no_data')}
        //       </Typography>
        //     </Stack>
        //   )
        // }
      >
        <BaseTimelineItem activityData={data} onView={onView} />
      </InfiniteScroll>
    </Box>
  );
};

export default BaseTimeline;
